<template>
    <div style="margin-top: 30px">
        <el-row>
            <el-col :span="6">
                <el-form-item label="治疗状态" prop="zhiliaozhuangtai"
                              :class="$store.state.registration.form9.indexOf('form7_zhiliaozhuangtai') >= 0?'container':''">
                    <el-select placeholder="治疗状态" v-model="form7.zhiliaozhuangtai" style="width: 60%">
                        <el-option label="完成治疗" value="完成治疗"></el-option>
                        <el-option label="提前终止治疗" value="提前终止治疗"></el-option>
                        <el-option label="正在治疗" value="正在治疗"></el-option>
                        <el-option label="未治" value="未治"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="生存状态" prop="shengcunzhuangtai"
                              :class="$store.state.registration.form9.indexOf('form7_shengcunzhuangtai') >= 0?'container':''">
                    <el-select placeholder="生存状态" v-model="form7.shengcunzhuangtai" disabled style="width: 60%">
                        <el-option label="存活" value="存活"></el-option>
                        <el-option label="死亡" value="死亡"></el-option>
                        <el-option label="放弃" value="放弃"></el-option>
                        <el-option label="失访" value="失访"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="6">
                <el-form-item label="医保类型" prop="yibaoleixing"
                              :class="$store.state.registration.form9.indexOf('form7_yibaoleixing') >= 0?'container':''">
                    <el-select placeholder="医保类型" v-model="form7.yibaoleixing" style="width: 60%">
                        <el-option label="城镇职工" value="城镇职工"></el-option>
                        <el-option label="城镇居民" value="城镇居民"></el-option>
                        <el-option label="新农合" value="新农合"></el-option>
                        <el-option label="重大疾病医疗保险" value="重大疾病医疗保险"></el-option>
                        <el-option label="商业保险" value="商业保险"></el-option>
                        <el-option label="外地医保" value="外地医保"></el-option>
                        <el-option label="自费" value="自费"></el-option>
                        <el-option label="其他" value="其他"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="全程治疗费用" prop="zhiliaofeiyong"
                              :class="$store.state.registration.form9.indexOf('form7_zhiliaofeiyong') >= 0?'container':''">
                    <el-input v-model="form7.zhiliaofeiyong" placeholder="￥0.00" style="width: 60%"
                              type="number"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
            <el-col :span="24">
                <el-form-item label="本病例是否为初发" label-width="150" style="margin-left: 30px">
                    <el-radio-group v-model="form7.is_chufa">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
            <el-col :span="11">
                <el-tooltip class="item"  placement="top" :tabindex='-1'>
                    <div slot="content">填写说明：可以填写住院号、录入人员姓名等信息。<br/><br/>操作说明：输入填写信息后，按回车输入框下面会新增一个标签。</div>
                    <el-form-item label="备注" >
                        <div style="display: inline">
                            <el-input
                                    style="width: 91%"
                                    placeholder="请输入内容"
                                    v-model="inputValue"
                                    @keyup.enter.native="handleInputConfirm"
                                    @blur="handleInputConfirm"
                            >
                            </el-input>
                            <el-tag
                                    :key="index"
                                    size="small"
                                    style="margin: 10px 5px"
                                    v-for="(tag,index) in form7.remarks"
                                    :closable="true"
                                    :disable-transitions="false"
                                    @close="handleClose(tag)">
                                {{tag}}
                            </el-tag>
                        </div>
                    </el-form-item>
                </el-tooltip>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form7: this.$store.state.registration.form7,
                rules: {},
                inputValue: ''
            };
        },
        methods: {
            handleClose(tag) {
                this.form7.remarks.splice(this.form7.remarks.indexOf(tag), 1);
            },

            handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                    this.form7.remarks.push(inputValue);
                }
                // this.inputVisible = false;
                this.inputValue = '';
            }
        }
    };
</script>

<style scoped>
    .container /deep/ .el-input__inner {
        color: red;
    }
     .el-tag + .el-tag {
         margin-left: 10px;
     }
</style>
